import { InjectionToken } from '@angular/core';

import { MiddlewareSDK, MiddlewareStore } from '..';

export const SDK = new InjectionToken<MiddlewareSDK>('eep.sdk');
export const STORE = new InjectionToken<MiddlewareStore>('eep.store');
